export const DOCUMENT_FILE_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".csv",
];

export const IMAGE_FILE_EXTENSIONS = [".jpeg", ".png", ".gif", ".webp"];

export const ALLOWED_FILE_EXTENSIONS = [
  ...DOCUMENT_FILE_EXTENSIONS,
  ...IMAGE_FILE_EXTENSIONS,
];

export const ALLOWED_FILE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "application/pdf",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/vnd.ms-excel",
];

export const MAX_CONTEXT_FILES_SIZE_MB = 50;
export const MAX_CONTEXT_FILES_SIZE_BYTES =
  MAX_CONTEXT_FILES_SIZE_MB * 1024 * 1024;

export const TOOLCALL_NAME_DISPLAY_MAP = {
  context_files_toolcall: "Reading files...",
  visualization_toolcall: "Preparing your plan...",
  read_context_files: "Reading files...",
  generate_visualization: "Preparing your plan...",
  web_search_toolcall: "Searching the web...",
  tavily_web_search: "Searching the web...",
  web_extract_toolcall: "Extracting web content...",
  tavily_web_extract: "Extracting web content...",
};
